// store/dashboardApi/dashboardThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as dashboardApi from "@/api/dashboardApi";

// ==================== ADMIN DASHBOARD THUNKS ====================

export const fetchAdminOverview = createAsyncThunk(
  "dashboard/fetchAdminOverview",
  async (_, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getAdminOverview();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTopPerformers = createAsyncThunk(
  "dashboard/fetchTopPerformers",
  async ({ period = "month", limit = 10 } = {}, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getTopPerformers(period, limit);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAdminActivityFeed = createAsyncThunk(
  "dashboard/fetchAdminActivityFeed",
  async ({ limit = 50 } = {}, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getAdminActivityFeed(limit);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== USER DASHBOARD THUNKS ====================

export const fetchUserDashboardOverview = createAsyncThunk(
  "dashboard/fetchUserDashboardOverview",
  async (_, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getUserDashboardOverview();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserTaskStats = createAsyncThunk(
  "dashboard/fetchUserTaskStats",
  async (_, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getUserTaskStats();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserPerformance = createAsyncThunk(
  "dashboard/fetchUserPerformance",
  async (_, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getUserPerformance();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserRecentTasks = createAsyncThunk(
  "dashboard/fetchUserRecentTasks",
  async ({ limit = 10 } = {}, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getUserRecentTasks(limit);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserActivity = createAsyncThunk(
  "dashboard/fetchUserActivity",
  async ({ limit = 20 } = {}, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.getUserActivity(limit);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ==================== ACTIVITY LOGGING ====================

export const createActivityLog = createAsyncThunk(
  "dashboard/createActivityLog",
  async (activityData, { rejectWithValue }) => {
    try {
      const data = await dashboardApi.logActivity(activityData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
